import { API, graphqlOperation } from "aws-amplify";
import {
  NotificationEvent,
  ListNotificationEventByInterviewIdSortBySortIndexQuery,
} from "types/graphqlapi";
import { listNotificationEventByInterviewIdSortBySortIndex } from "graphql/queries";

export const fetchNotificationEventByInterviewIdQuery = async (
  interviewId: string
) => {
  let list: NotificationEvent[] = [];
  let nextToken = null;

  do {
    const result = (await API.graphql(
      graphqlOperation(listNotificationEventByInterviewIdSortBySortIndex, {
        interview_id: interviewId,
        limit: 100,
        nextToken,
      })
    )) as {
      data: ListNotificationEventByInterviewIdSortBySortIndexQuery;
    };
    const data = result.data.listNotificationEventByInterviewIdSortBySortIndex;
    const items = (data?.items || []) as NotificationEvent[];

    nextToken = data?.nextToken;

    list = [...list, ...items];
  } while (nextToken);

  return list;
};
